module.exports = __webpack_public_path__ + "img/djuli-report-easy.18122daa.png";